import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AppRoutes } from "./routes/AppRoutes";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { fetchOneCreditNotifications } from "./store/slices/notificacions.slice";
import { useSessionTimeout } from "./hooks/useSessionTimeout";

function App() {
  const dispatch = useDispatch();

  // Monitorear expiración de sesión
  useSessionTimeout();

  useEffect(() => {
    // Cargar notificaciones al inicio
    dispatch(fetchOneCreditNotifications());
  }, []);

  return (
    <>
      <AppRoutes />
      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
}

export default App;
